import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/productivity',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
            moduleKey: 'productivity',
        },
        children: [
            {
                path: '',
                name: 'productivity-dashboard',
                component: () => import('./views/ProductivityDashboard.vue'),
            },
            {
                path: 'employees',
                name: 'productivity-employees',
                component: () => import('./views/ProductivityEmployees.vue'),
            },
            {
                path: 'classifications',
                name: 'productivity-classifications',
                component: () => import('./views/ClassificationSettings.vue'),
            },
            {
                path: ':username',
                name: 'productivity-detail',
                component: () => import('./views/ProductivityDetail.vue'),
                props: true,
            },
        ],
    },
]

export default routes
